<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="二手车名称">
          <el-input
            placeholder="请输入二手车名称"
            v-model="formInline.search"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>



    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="used_car_id" label="id"></el-table-column>
               <el-table-column prop="name" label="名称"></el-table-column>
               <el-table-column prop="type" label="类型">
                   <template slot-scope="scope">
                <div v-if="scope.row.type == 0">二手交易车辆</div>
                <div v-if="scope.row.type == 1">其余地方看到车辆</div>
 
              </template>

               </el-table-column>
            <el-table-column prop="model" label="型号"></el-table-column>
            <el-table-column prop="user_id" label="发布人"></el-table-column>
            <el-table-column prop="price" label="价格">
              <template slot-scope="scope">
                {{ scope.row.price }}万元
              </template>
            </el-table-column>
            <!-- <el-table-column prop="intro" label="详情"></el-table-column> -->
            <el-table-column prop="brand" label="品牌"></el-table-column>
            <!-- <el-table-column prop="image" label="图片"></el-table-column> -->
            <el-table-column prop="year" label="年份"></el-table-column>
            <el-table-column prop="duration" label="年限"></el-table-column>
            <!-- <el-table-column prop="exterior" label="外观"></el-table-column> -->

            <el-table-column
            label="检测状态"
            prop="vehicle.inspection_status"
            
          >
            <template slot-scope="scope">
              {{ 
                scope.row.vehicle.inspection_status === 0 ? '未检测' : 
                scope.row.vehicle.inspection_status === 1 ? '已检测' : '检测异常' 
              }}
            </template>
          </el-table-column>

          <el-table-column
            label="外观检测"
            prop="vehicle.appearance_inspection"
            
          />

          <el-table-column
            label="功能测试"
            prop="vehicle.function_test"
            
          />

          <el-table-column
            label="电路系统"
            prop="vehicle.circuit_system"
            
          />

          <el-table-column
            label="液压压力(MPa)"
            prop="vehicle.hydraulic_pressure"
            
          />

          <el-table-column
            label="发动机缸压(MPa)"
            prop="vehicle.engine_cylinder_pressure"
            
          />

          <el-table-column
            label="检测备注"
            prop="vehicle.inspection_notes"
            
            show-overflow-tooltip
          />

          <el-table-column
            label="检测时间"
            prop="vehicle.inspection_time"
            
          >
            <template slot-scope="scope">
              {{ scope.row.vehicle.inspection_time  }}
            </template>
          </el-table-column>



            <el-table-column prop="e_hour" label="发动机小时"></el-table-column>
            <el-table-column prop="wt_hour" label="风机小时"></el-table-column>
            <el-table-column label="审核状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">未审核</div>
                <div v-if="scope.row.status == 1">审核通过</div>
                <div v-if="scope.row.status == 2">审核未通过</div>
              </template>
            </el-table-column>

            <el-table-column
              prop="reject_val"
              label="审核不通过原因"
            ></el-table-column>

            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.is_gf == 0"
                  @click="editGf(scope.row,1)"
                  type="text"
                  size="small"
                  >官方认证</el-button
                >
                <el-button
                  v-else 
                  @click="editGf(scope.row,0)"
                  type="text"
                  size="small"
                  >取消官方认证</el-button
                >
                <el-button
                  v-if="scope.row.status == 0"
                  @click="passClick(scope.row)"
                  type="text"
                  size="small"
                  >审核</el-button
                >
                <el-button
                  v-if="scope.row.status == 0"
                  @click="nopassClick(scope.row)"
                  type="text"
                  size="small"
                  >审核不通过</el-button
                >
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit
      :open_add="open_edit"
      :used_car_id="used_car_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import UsedCarApi from "@/api/used_car.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },

      open_add: false,
      open_edit: false,
      used_car_id: "",
      dialogVisible: false
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    editGf(item,is_gf){
      var self = this;
      var Params = {
        used_car_id: item.used_car_id,
        is_gf: is_gf
      };
      UsedCarApi.editGf(Params, true)
        .then(data => {
          console.log(data);
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "认证成功"
            });
            self.getTableList();
            return false;
          }
        })
        .catch(error => {});


    },
    passClick(item) {
      //通过审核
      var self = this;
      var Params = {
        used_car_id: item.used_car_id,
        status: 1
      };
      UsedCarApi.passCanel(Params, true)
        .then(data => {
          console.log(data);
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "审核成功"
            });
            self.getTableList();
            return false;
          }
        })
        .catch(error => {});
    },
    async nopassClick(item) {
      //不通过审核
      var self = this;
      const reject_val = await this.promptInput(
        "请输入不通过的原图",
        "请输入2-4个汉字"
      );

      var Params = {
        used_car_id: item.used_car_id,
        status: 2,
        reject_val: reject_val
      };
      UsedCarApi.passCanel(Params, true)
        .then(data => {
          if (data.code == 1) {
            self.$message({
              type: "success",
              message: "审核成功"
            });
            self.getTableList();
            return false;
          }
        })
        .catch(error => {});
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputErrorMessage: validation
        });
        return value.trim();
      } catch (e) {
        this.$message({
          type: "info",
          message: "取消输入"
        });
      }
    },
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //二手车标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      UsedCarApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.used_car_id = row.used_car_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          UsedCarApi.del(
            {
              used_car_id: row.used_car_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/used_car/index/index.vue